export enum USER_DIRECTORY {
    /**
     * @value Edit main user directory
     */
    EDIT_MAIN_USER_DIRECTORY = 'USER_DIRECTORY.EDIT_MAIN_USER_DIRECTORY',
    /**
     * @value The main user directory of the default site is %TITLE%.
     */
    MAIN_DIRECTORY_MESSAGE = 'USER_DIRECTORY.MAIN_DIRECTORY_MESSAGE',
    /**
     * @value This option is only available on the default site when NGI is active. Switch to the default site to manage this setting.
     */
    NOT_DEFAULT_SITE_TOOLTIP = 'USER_DIRECTORY.NOT_DEFAULT_SITE_TOOLTIP',
    /**
     * @value No main user directory is configured on the default site of the platform. Some features need it to run to their full capacity.
     */
    NO_MAIN_DIRECTORY_MESSAGE = 'USER_DIRECTORY.NO_MAIN_DIRECTORY_MESSAGE',
}
